/**
 * @generated SignedSource<<09503033bac1fa9fcb4ae012b0572f90>>
 * @relayHash ac383d63d04c0b708d9866a4a18334df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 005d6d4cceaf040ceeeed810ca8d15af4ac161c7ba5a29d25031b4ad95427145

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "005d6d4cceaf040ceeeed810ca8d15af4ac161c7ba5a29d25031b4ad95427145",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
